import { Currency, ETHER, Token } from '@ekliptor/1bch-sdk'

export function currencyId(currency: Currency): string {
  //if (currency === ETHER) return 'BNB'
  if (currency === ETHER) return 'BCH' // todo xxxx enter BCH
  //if (currency === ETHER) return 'DtBCH'
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}

export default currencyId
